/*
 * @Date: 2022-08-29 09:58:11
 * @LastEditors: kinfai
 * @Description: 聊天用户信息
 * @LastEditTime: 2022-08-30 14:33:30
 * @FilePath: \my-app\src\pages\ChatConversation\components\UserInfo\index.jsx
 */
import './index.less'
import useCs from "@/hooks/cs/index.js";


import {useContext, useEffect, useState, memo} from "react";
import {RouteContext} from "@/provide/route-context";

import BgHeader from "@/components/BgHeader";
import {LeftOutlined} from '@ant-design/icons';
import {Avatar} from 'antd';
import useTurms from "../../../../hooks/turms/index.js";


function UserInfo(props) {
    const [kefuInfo, setKefuInfo] = useState({
        name: 'Customer service',
        status: 1,
        Avatar: ""
    })

    const {getKefu, editCsid} = useCs()
    const context = useContext(RouteContext)
    const handelBack = () => {
        // context.goPage('Home')
        const changeShow = props.setShow
        changeShow(false)
    }

    const queryKf = async () => {
        const kefuInfo = await getKefu()
        // console.log("拉取", kefuInfo)
        // console.log("客服头像", kefuInfo.avatar)
        if (JSON.stringify(kefuInfo) !== "{}") {
            setKefuInfo(kefuInfo)
        }
    }

    const {getTurms} = useTurms()
    const watchUpate = async () => {
        const turms = await getTurms()
        turms.notificationService.addNotificationListener(async msg => {
            try {
                const text = JSON.parse(msg.relayedRequest.createNeedkeNotifyRequest.text)
                const kfId = text.kfId
                editCsid(kfId)
                await getKefu(true)
                await queryKf()

            } catch (e) {
                console.log("通知消息-error", e)
            }
        })

    }

    let isFirst = true
    useEffect(() => {
        const queryKf = async () => {
            const kefuInfo = await getKefu()
            // console.log("拉取", kefuInfo)
            // console.log("客服头像", kefuInfo.avatar)
            if (JSON.stringify(kefuInfo) !== "{}") {
                setKefuInfo(kefuInfo)
            }
        }

        if (isFirst) {
            queryKf()
            watchUpate()
        }

        // isFirst && queryKf()

        return () => {
            isFirst = false
        }
    }, [])

    const Content = () => {
        return <div className="g-chat-user-info">
            <LeftOutlined style={{
                fontSize: "24px",
                color: 'white',
                cursor: "pointer"
            }}
                          onClick={handelBack}
            />
            <Avatar
                src={kefuInfo.avatar}
                style={{marginLeft: "12px", marginRight: "7px",}}
            />
            <div className="g-user-info">
                <p className='s-name'>{kefuInfo.name}</p>
                <p className='s-status'>{
                    kefuInfo.online ? 'onLine' : 'offline'
                }</p>
            </div>
        </div>
    }

    return <BgHeader height="70px" subComponent={Content}></BgHeader>
}

export default memo(UserInfo);
